<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Shipment Summary
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="tableHeaders"
      :items="tableData"
      :loading="listLoader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1 custom-icon-size"
      :hide-default-footer="true"
    >
      <template v-slot:no-data>
        <div class="text-center">No data available</div>
      </template>
      <template v-slot:body>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td
              v-for="header in tableHeaders"
              :key="header.value"
              class="width"
              :class="
                typeof item[header.value] == 'number'
                  ? 'text-end'
                  : 'text-start'
              "
            >
              <template>
                <a
                  @click="gotodetails(item.CLIENT_ID, header.value)"
                  v-if="typeof item[header.value] == 'number'"
                  >{{ item[header.value] }}</a
                >
                <span v-if="typeof item[header.value] == 'string'">{{
                  item[header.value]
                }}</span>
              </template>
              <!-- <template v-else>
                {{ item[header.value] }}
              </template> -->
              <!-- <template v-else-if="item.status.hasOwnProperty(header.value)">
                {{ item.status[header.value] }}
              </template>
              <template v-else> - </template> -->
            </td>
          </tr>

          <!-- Add a row for "Total" -->
          <tr
            class="total-row"
            style="background-color: lightskyblue; font-size: 17px"
          >
            <td class="pl-3" style="text-align: left"><b>Total</b></td>
            <td></td>

            <td
              v-for="header in tableHeaders.slice(2)"
              :key="header.value"
              style="text-align: right"
            >
              <!-- If the header exists in the total object, display the value -->
              <template v-if="totalarr.hasOwnProperty(header.value)">
                <b>{{ totalarr[header.value] }}</b>
              </template>
              <!-- Otherwise, display an empty cell -->
              <template v-else> - </template>
            </td>
          </tr>
        </tbody>
      </template>
      <template v-slot:footer> </template>
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions } from "vuex";

export default {
  computed: {
    tableHeaders() {
      const headerObjects = [
        {
          text: "CLIENT_NAME",
          value: "CLIENT_NAME",
          sortable: false,
          align: "left",
        },
        {
          text: "SERVICE_NAME",
          value: "SERVICE_NAME",
          sortable: false,
          align: "left",
        },
        ...this.status.map((header) => ({
          text: header,
          value: header,
          sortable: false,
          align: "right",
        })),
      ];
      return headerObjects;
    },
    tableData() {
      return this.summary;
    },
  },
  created() {
    this.fetchSummary(); // Fetch the data when the component is created
  },
  data: () => ({
    total: 0,
    totalarr: [],
    options: {},
    listLoader: false,
    status: [],
    summary: [], // Initialize as an empty array
  }),

  watch: {
    options: {
      handler() {
        // Handle option changes if needed
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(["getFulfillmentOrderSummary"]),
    gotodetails(id, value) {
      this.$router.push({
        name: "OrderList",
        params: {
          id: id,
          value: value,
        },
      });
    },
    async fetchSummary() {
      await this.getFulfillmentOrderSummary().then((response) => {
        this.summary = response.data.result;
        this.status = response.data.status;
        this.totalarr = response.data.total;
      });
    },
  },
};
</script>
